<div class="list-toolbar">
  <p class="hint">
    <mat-icon>info</mat-icon>
    Suppliers can only add destinations under, and request payment to, active methods.
    Deactivating one does not affect requests already made to it.
  </p>
  @if (canEdit) {
  <button mat-flat-button color="primary" type="button" (click)="openDialog()">
    <mat-icon>add</mat-icon> Add method
  </button>
  }
</div>

<div class="table-card">
@if (loading) {
<div class="table-state"><mat-spinner diameter="28"></mat-spinner></div>
} @else if (error) {
<div class="table-state error">{{ error }}</div>
} @else if (methods.length === 0) {
<div class="table-state">No payout methods yet. Suppliers cannot request payment until one is active.</div>
} @else {
<div class="table-scroll">
  <table mat-table [dataSource]="methods">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let m"><span class="strong">{{ m.name }}</span></td>
    </ng-container>
    <ng-container matColumnDef="kind">
      <th mat-header-cell *matHeaderCellDef>Kind</th>
      <td mat-cell *matCellDef="let m">{{ m.kind === 'Bank' ? 'Bank card / Shaba' : 'Crypto wallet' }}
        @if (m.onchain_network) { <div class="sub">Sent from the hot wallet ({{ m.onchain_network }})</div> }
      </td>
    </ng-container>
    <ng-container matColumnDef="pattern">
      <th mat-header-cell *matHeaderCellDef>Address pattern</th>
      <td mat-cell *matCellDef="let m">
        @if (m.kind !== 'Wallet') {
        <span class="muted">Card or Shaba, checksum-validated</span>
        } @else {
        <span class="mono" dir="ltr">{{ m.address_pattern || 'any' }}</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="rate">
      <th mat-header-cell *matHeaderCellDef>Rate (Toman per coin)</th>
      <td mat-cell *matCellDef="let m">
        @if (m.kind !== 'Wallet') {
        <span class="muted">—</span>
        } @else {
        <div class="rate">
          <div>
            <span class="strong num">{{ currentRate(m) ? (+currentRate(m)! | number) : '—' }}</span>
            <div class="sub">
              {{ m.rate_source }}@if (m.rate_symbol) { · {{ m.rate_symbol | uppercase }} } · {{ m.amount_decimals }} decimals
              @if (m.rate_source !== 'Manual' && m.last_rate_at) {
              <span [class.stale]="isStale(m)"> · fetched {{ m.last_rate_at | date:'short' }}</span>
              }
            </div>
          </div>
          @if (canEdit && m.rate_source !== 'Manual') {
          <button mat-icon-button type="button" matTooltip="Fetch the rate now" [disabled]="refreshing === m.id"
            (click)="refreshRate(m)">
            <mat-icon>refresh</mat-icon>
          </button>
          }
        </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef>Active</th>
      <td mat-cell *matCellDef="let m">
        <mat-slide-toggle [checked]="m.active" [disabled]="!canEdit" (change)="setActive(m, $event.checked)"></mat-slide-toggle>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let m" class="actions">
        @if (canEdit) {
        <button mat-icon-button type="button" matTooltip="Edit" (click)="openDialog(m)"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button type="button" matTooltip="Delete (only if unused)" (click)="remove(m)"><mat-icon>delete</mat-icon></button>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns" [class.inactive]="!row.active"></tr>
  </table>
</div>
}
</div>
